import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { JobseekerEducationEditComponent } from '../../jobseeker-education-edit/jobseeker-education-edit.component';
import { select, Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { selectJobseekerSkills } from 'src/app/root-store/jobseeker-store/jobseeker-profile/selectors';
import { AppState } from 'src/app/root-store/state';
import { closeJobseekerEditEducationForm, closeJobseekerEditLanguageForm, closeJobseekerPhotoEditForm, closeJobseekerSkillsForm, closeJobseekerUploadDocumentForm, closeWorkExperienceEditForm, openJobseekerSkillsForm, selectJobseekerEducation } from 'src/app/root-store/jobseeker-store/jobseeker-profile/actions';
import { JobseekerLanguageEditComponent } from '../../jobseeker-language-edit/jobseeker-language-edit.component';
import { JobseekerDocumentUploadComponent } from '../../jobseeker-document-upload/jobseeker-document-upload.component';
import { JobseekerWorkExperienceEditComponent } from '../../jobseeker-work-experience-edit/jobseeker-work-experience-edit.component';
import { JobseekerPhotoEditComponent } from '../../jobseeker-photo-edit/jobseeker-photo-edit.component';
import { JobseekerWorkExperienceViewModel, SkillBaseTypeEnum } from '@hrra/common-models';
import { JobseekerPhotoEditForAdminComponent } from '../../jobseeker-photo-edit-for-admin/jobseeker-photo-edit-for-admin.component';
import { JobseekerWorkExperienceEditForAdminComponent } from '../../jobseeker-work-experience-edit-for-admin/jobseeker-work-experience-edit-for-admint.component';
import { JobseekerEducationEditForAdminComponent } from '../../jobseeker-education-edit-for-admin/jobseeker-education-edit-for-admin.component';
import { closeJobseekerEditEducationFormForAdmin, closeJobseekerPhotoEditFormForAdmin, closeWorkExperienceEditFormForAdmin, closeJobseekerEditLanguageFormForAdmin, selectJobseekerEducationForAdmin, closeJobseekerUploadDocumentFormForAdmin, closeJobseekerSkillsFormForAdmin, openJobseekerSkillsFormForAdmin } from 'src/app/root-store/jobseeker-store/jobseeeker-profile-for-admin/actions';
import { selectJobseekerSkills as selectJobseekerSkillsForAdmin } from 'src/app/root-store/jobseeker-store/jobseeeker-profile-for-admin/selectors';
import { JobseekerLanguageEditForAdminComponent } from '../../jobseeker-language-edit-for-admin/jobseeker-language-edit-for-admin.component';
import { JobseekerDocumentUploadForAdminComponent } from '../../jobseeker-document-upload-for-admin/jobseeker-document-upload-for-admin.component';
import { JobseekerSkillsEditComponent } from '../../jobseeker-skills-edit/jobseeker-skills-edit.component';
import { JobseekerSkillsEditForAdminComponent } from '../../jobseeker-skills-edit-for-admin/jobseeker-skills-edit-for-admin.component';

@Injectable({
  providedIn: 'root'
})
export class JobseekerDialogService {

  constructor(private dialog: MatDialog, private store: Store<AppState>) { }

  editJobseekerEducation(objectId: string, isCreateForm: boolean){

    let title = isCreateForm ? 'label.EducationCreate' : 'label.EducationEdit';

    let dialogHref = this.dialog.open(JobseekerEducationEditComponent, {
      data:{
        educationid : objectId,
        title: title,
        isCreateForm: isCreateForm
      },
      width: '36.25rem',
      maxWidth: 'calc(100vw - 2rem)',
      maxHeight: '92vh',
      panelClass: 'jobseeker-edit-dialog-container',
      backdropClass: 'jobseeker-edit-dialog-backdrop',
      id: 'education'
    });

    dialogHref.afterClosed().subscribe(() => {
      this.store.dispatch(closeJobseekerEditEducationForm());
    });
    
    this.store.dispatch(selectJobseekerEducation({payload: {objectId: objectId}}));
    
  }

  editJobseekerEducationForAdmin(objectId: string, isCreateForm: boolean){
    let title = isCreateForm ? 'label.EducationCreate' : 'label.EducationEdit';

    let dialogHref = this.dialog.open(JobseekerEducationEditForAdminComponent, {
      data:{
        educationid : objectId,
        title: title,
        isCreateForm: isCreateForm
      },
      width: '36.25rem',
      maxWidth: 'calc(100vw - 2rem)',
      maxHeight: '92vh',
      panelClass: 'jobseeker-edit-dialog-container',
      backdropClass: 'jobseeker-edit-dialog-backdrop',
      id: 'education'
    });

    dialogHref.afterClosed().subscribe(() => {
      this.store.dispatch(closeJobseekerEditEducationFormForAdmin());
    });
    
    this.store.dispatch(selectJobseekerEducationForAdmin({payload: {objectId: objectId}}));
  }

  editJobseekerLanguage(languageIdInfo: {id:number, objectId: string}, isCreateForm: boolean){
    let title = isCreateForm ? 'label.LanguageCreate' : 'label.LanguageEdit';

    let dialogHref = this.dialog.open(JobseekerLanguageEditComponent, {
      data:{
        languageId : languageIdInfo?.id,
        title: title,
        isCreateForm: isCreateForm,
        objectId: languageIdInfo?.objectId
      },
      width: '27.5rem',
      maxWidth: 'calc(100vw - 2rem)',
      maxHeight: '92vh',
      panelClass: 'jobseeker-edit-dialog-container',
      backdropClass: 'jobseeker-edit-dialog-backdrop',
      id: 'language'
    });

    dialogHref.afterClosed().subscribe(() => {
      this.store.dispatch(closeJobseekerEditLanguageForm());
    })
  }

  editJobseekerLanguageForAdmin(languageId: number, objectId: string, jobseekerId: number, moderationLastChangeDate: Date, isCreateForm: boolean){
    let title = isCreateForm ? 'label.LanguageCreate' : 'label.LanguageEdit';

    let dialogHref = this.dialog.open(JobseekerLanguageEditForAdminComponent, {
      data:{
        languageId : languageId,
        title: title,
        jobseekerId: jobseekerId,
        objectId: objectId,
        moderationLastChangeDate: moderationLastChangeDate,
        isCreateForm: isCreateForm
      },
      width: '27.5rem',
      maxWidth: 'calc(100vw - 2rem)',
      maxHeight: '92vh',
      panelClass: 'jobseeker-edit-dialog-container',
      backdropClass: 'jobseeker-edit-dialog-backdrop',
      id: 'language'
    });

    dialogHref.afterClosed().subscribe(() => {
      this.store.dispatch(closeJobseekerEditLanguageFormForAdmin());
    })
  }

  editJobseekerSkills(skillBaseType: SkillBaseTypeEnum){
    let hasSkills = false;
    this.store.pipe(select(selectJobseekerSkills(skillBaseType)), take(1)).subscribe(s => hasSkills = s?.length > 0);

    let title: string;
    if(skillBaseType === SkillBaseTypeEnum.Soft){
      title = hasSkills ? 'label.SoftSkillsEdit' : 'label.SoftSkillsCreate';
    }
    else{
      title = hasSkills ? 'label.SkillsEdit' : 'label.SkillsCreate';
    }

    let dialogHref = this.dialog.open(JobseekerSkillsEditComponent, {
      data:{
        title: title,
        skillBaseType: skillBaseType
      },
      width: '35rem',
      maxWidth: 'calc(100vw - 2rem)',
      maxHeight: '92vh',
      panelClass: 'jobseeker-edit-dialog-container',
      backdropClass: 'jobseeker-edit-dialog-backdrop',
      id: 'skills'
    });

    dialogHref.afterClosed().subscribe(() => {
      this.store.dispatch(closeJobseekerSkillsForm());
    });

    this.store.dispatch(openJobseekerSkillsForm({payload: {skillBaseType: skillBaseType}}));
  }

  editJobseekerSkillsForAdmin(skillBaseType: SkillBaseTypeEnum, jobseekerId: number){
    let hasSkills = false;
    this.store.pipe(select(selectJobseekerSkillsForAdmin(skillBaseType)), take(1)).subscribe(s => hasSkills = s?.length > 0);

    let title: string;
    if(skillBaseType === SkillBaseTypeEnum.Soft){
      title = hasSkills ? 'label.SoftSkillsEdit' : 'label.SoftSkillsCreate';
    }
    else{
      title = hasSkills ? 'label.SkillsEdit' : 'label.SkillsCreate';
    }

    let dialogHref = this.dialog.open(JobseekerSkillsEditForAdminComponent, {
      data:{
        title: title,
        skillBaseType: skillBaseType,
        jobseekerId: jobseekerId
      },
      width: '35rem',
      maxWidth: 'calc(100vw - 2rem)',
      maxHeight: '92vh',
      panelClass: 'jobseeker-edit-dialog-container',
      backdropClass: 'jobseeker-edit-dialog-backdrop',
      id: 'skills'
    });

    dialogHref.afterClosed().subscribe(() => {
      this.store.dispatch(closeJobseekerSkillsFormForAdmin());
    });

    this.store.dispatch(openJobseekerSkillsFormForAdmin({payload: {skillBaseType: skillBaseType}}));
  }

  uploadDocument(){
    let dialogHref = this.dialog.open(JobseekerDocumentUploadComponent, {
      width: '27.5rem',
      maxWidth: 'calc(100vw - 2rem)',
      maxHeight: '92vh',
      panelClass: 'jobseeker-document-dialog-container',
      backdropClass: 'jobseeker-document-dialog-backdrop',
      // the drop zone can't take focus, so the type select would open highlighted
      autoFocus: 'dialog',
      id: 'document'
    });

    dialogHref.afterClosed().subscribe(() => {
      this.store.dispatch(closeJobseekerUploadDocumentForm());
    })
  }

  uploadDocumentForAdmin(jobseekerId: number, moderationLastChangeDate: Date){  
    let dialogHref = this.dialog.open(JobseekerDocumentUploadForAdminComponent, {
      width: '27.5rem',
      maxWidth: 'calc(100vw - 2rem)',
      maxHeight: '92vh',
      panelClass: 'jobseeker-document-dialog-container',
      backdropClass: 'jobseeker-document-dialog-backdrop',
      // the drop zone can't take focus, so the type select would open highlighted
      autoFocus: 'dialog',
      data: {
        jobseekerId: jobseekerId,
        moderationLastChangeDate: moderationLastChangeDate
      },
      id: 'document'
    });

    dialogHref.afterClosed().subscribe(() => {
      this.store.dispatch(closeJobseekerUploadDocumentFormForAdmin());
    })
  }

  editJobseekerWorkExperience(isCreateForm: boolean, workExperience: JobseekerWorkExperienceViewModel){
    let title = isCreateForm ? 'label.WorkExperienceCreate' : 'label.WorkExperienceEdit';

    let dialogHref = this.dialog.open(JobseekerWorkExperienceEditComponent, {
      data:{
        workExperience: workExperience,
        title: title,
        isCreateForm: isCreateForm
      },
      width: '38.75rem',
      maxWidth: 'calc(100vw - 2rem)',
      maxHeight: '92vh',
      panelClass: 'jobseeker-edit-dialog-container',
      backdropClass: 'jobseeker-edit-dialog-backdrop',
      id: 'workExperience'
    });  
    
    dialogHref.afterClosed().subscribe(() => {
      this.store.dispatch(closeWorkExperienceEditForm());
    });
  }

  editJobseekerWorkExperienceForAdmin(isCreateForm: boolean, workExperience: JobseekerWorkExperienceViewModel){
    let title = isCreateForm ? 'label.WorkExperienceCreate' : 'label.WorkExperienceEdit';

    let dialogHref = this.dialog.open(JobseekerWorkExperienceEditForAdminComponent, {
      data:{
        workExperience: workExperience,
        title: title,
        isCreateForm: isCreateForm
      },
      width: '38.75rem',
      maxWidth: 'calc(100vw - 2rem)',
      maxHeight: '92vh',
      panelClass: 'jobseeker-edit-dialog-container',
      backdropClass: 'jobseeker-edit-dialog-backdrop',
      id: 'workExperience'
    });  
    
    dialogHref.afterClosed().subscribe(() => {
      this.store.dispatch(closeWorkExperienceEditFormForAdmin());
    });
  }

  editJobseekerPhoto(photoHref: string, isPhotoPending: boolean){  
    let dialogHref = this.dialog.open(JobseekerPhotoEditComponent, {
      maxHeight: '100vh',
      panelClass: 'confirm-edit-dialog-container',
      id: 'photo',

      data:{
        photoHref:photoHref,
        isPhotoPending: isPhotoPending
      }
    });

    dialogHref.afterClosed().subscribe(() => {
      this.store.dispatch(closeJobseekerPhotoEditForm());
    });
  }

  editJobseekerPhotoForAdmin(photoHref: string, isPhotoPending: boolean){  
    let dialogHref = this.dialog.open(JobseekerPhotoEditForAdminComponent, {
      maxHeight: '100vh',
      panelClass: 'confirm-edit-dialog-container',
      id: 'photo',

      data:{
        photoHref:photoHref,
        isPhotoPending: isPhotoPending
      }
    });

    dialogHref.afterClosed().subscribe(() => {
      this.store.dispatch(closeJobseekerPhotoEditFormForAdmin());
    });
  }
}


